export default __webpack_public_path__ + "static/media/advanced-settings-white.30de594f.svg";